import { ComplexEnumItem } from './ComplexEnumItem'

export class NamedComplexEnumItem<
  ID extends Lowercase<string> = Lowercase<string>,
  Name extends string = string
> extends ComplexEnumItem<ID> {
  /**
   * the human readable name of the complex enum item
   *
   * this will be displayed in CIMS
   *
   * for best usability, the key associated with this item should be a
   * variable-like version of this value
   */
  readonly name: Name
  /**
   * @see {@link ComplexEnumItem}
   */
  constructor({
    id,
    name,
  }: Pick<NamedComplexEnumItem<ID, Name>, 'id' | 'name'>) {
    super(id)
    this.name = name
  }
}
